import React, { useState, useEffect, useRef } from 'react';
// import ChevronDown from '../../../PostNewItemPage/ChevronDown';
import ChevronDown from '../../PostNewItemPage/ChevronDown';
import './DropDownLocation.css';
import useNewPostStore from '../../../../store/newPostStore';

export default function DropDownLocation({ options, cityOrTown, setCityOrTown }) {
  const { updateField, customCity } = useNewPostStore();

  const [isOpen, setIsOpen] = useState(false);
  const [isRotated, setIsRotated] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const dropdownRef = useRef(null);
  const locationInputRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setIsRotated(false);
      }
    };

    const handleKeydown = (event) => {
      if (event.key === 'Tab') {
        const focusableElements = dropdownRef.current.querySelectorAll(
          'li.drop-down-option'
        );
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      } else if (event.key === 'Escape') {
        setIsOpen(false);
        setIsRotated(false);
        locationInputRef.current?.focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        setFocusedIndex((prevIndex) => {
          if (prevIndex === 0) {
            return options.length - 1;
          } else {
            return prevIndex - 1;
          }
        });
      } else if (event.key === 'ArrowDown') {
        event.preventDefault();
        setFocusedIndex((prevIndex) => {
          if (prevIndex === options.length - 1) {
            return 0;
          } else {
            return prevIndex + 1;
          }
        });
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('keydown', handleKeydown);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('keydown', handleKeydown);
    };
  }, [locationInputRef, options.length]);

  useEffect(() => {
    if (isOpen) {
      const focusableElements = dropdownRef.current.querySelectorAll(
        'li.drop-down-option'
      );
      const focusedElement = focusableElements[focusedIndex];
      focusedElement?.focus();
    }
  }, [isOpen, focusedIndex]);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsOpen((prevState) => !prevState);
    setIsRotated((prevState) => !prevState);

    if (!isOpen) {
      setTimeout(() => {
        dropdownRef.current?.focus();
      }, 0);
    }
  };

  const handleOptionClick = (option) => {
    if (setCityOrTown) setCityOrTown(option);
    updateField('customCity', option);
    setIsOpen(false);
    setIsRotated(false);
  };

  return (
    <div className='drop-down' ref={dropdownRef} tabIndex={-1}>
      <div className='drop-down-chosen' onClick={toggleDropdown}>
        {cityOrTown ? cityOrTown : 'Select city or town'}
        <button
          className={`owned-down-btn ${isRotated ? 'rotated' : ''}`}
          ref={locationInputRef}>
          <ChevronDown className={'owned-down-chevron-green'} />
        </button>
      </div>
      {isOpen && (
        <div className='drop-down-wrapper'>
          <ul className={'options drop-down-options-location'}>
            {options.map((option, index) => (
              <li
                className={`drop-down-option-green${
                  option === cityOrTown ? ' selected' : ''
                }${index === focusedIndex ? ' focused' : ''}`}
                key={index}
                onClick={() => handleOptionClick(option)}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    handleOptionClick(option);
                  }
                }}
                tabIndex={0}>
                {option}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
